// extracted by mini-css-extract-plugin
export default {"header":"_36VuzQ3I","heading":"_3KCAH-mh","filteredLabel":"_11Wy85_h","bestMatchLink":"_12IcH_a_"};